// components/LoadingSpinner.jsx
import React from 'react';
import { Spin } from 'antd';

const LoadingSpinner = ({ loading }) => (
  <Spin
    size="large"
    tip="Chargement en cours..."
    spinning={loading}
    fullscreen={loading}
  />
);

export default LoadingSpinner;